<script>
	import { createEventDispatcher } from "svelte";
	import Textfield from "@smui/textfield";
	import Icon from "@smui/textfield/icon";
	import HelperText from "@smui/textfield/helper-text";
	import IconButton from "@smui/icon-button";
	import { isTranslationTooLong } from "../../../utils";

	export let string;
	export let translation = null;
	export let is_machine_translation = false;
	export let suggestion = null;
	export let input = "";

	const dispatch = createEventDispatcher();

	$: isTooLong = isTranslationTooLong(string?.length, input?.length);
	$: showSuggestion = !!suggestion && !input;
	$: rowDirty = (input || "") !== (translation || "");
</script>

<div
	class="geo-translation"
	class:machine={is_machine_translation}
	class:too-long={isTooLong}
	data-geo-string={string}
>
	<div class="field">
		<Textfield variant="filled" label={string} bind:value={input} on:input={() => dispatch("edit", input)}>
			{#if is_machine_translation}
				<Icon class="material-icons" slot="leadingIcon">smart_toy</Icon>
			{/if}
			<HelperText slot="helper" persistent={isTooLong || showSuggestion}>
				{#if isTooLong}
					Translation is significantly longer than original
				{:else if showSuggestion}
					suggestion:
					<button
						type="button"
						class="apply-suggestion"
						on:click={() => dispatch("edit", suggestion.translation)}
					>
						"{suggestion.translation}"
					</button>
					(from another graphic)
				{/if}
			</HelperText>
		</Textfield>
	</div>
	<div class="actions">
		<IconButton
			class="material-icons"
			size="mini"
			disabled={rowDirty}
			title={rowDirty ? "Save your changes first" : "Machine translate this name"}
			on:click={() => dispatch("machineTranslate")}
		>
			smart_toy
		</IconButton>
		<IconButton class="material-icons" size="mini" title="Clear translation" on:click={() => dispatch("clear")}>
			close
		</IconButton>
	</div>
</div>

<style lang="scss">
	.geo-translation {
		display: flex;
		align-items: flex-start;
		gap: 2px;

		.field {
			flex: 1;
			min-width: 0;

			:global(.mdc-text-field--filled) {
				width: 100%;
			}
		}

		.actions {
			display: flex;
			padding-top: 4px;
		}
	}

	.apply-suggestion {
		border: none;
		background: none;
		padding: 0;
		font: inherit;
		color: inherit;
		text-decoration: underline;
		cursor: pointer;
	}

	.machine {
		:global(.mdc-text-field__icon--leading) {
			position: relative;
			top: 6px;
			padding-left: 0;
			font-size: 20px;
			padding-right: 5px;
			color: $warning !important;
		}
	}

	.too-long {
		$length-warning: #ffc107; // amber-500

		:global(.mdc-text-field__input) {
			caret-color: $length-warning !important;
		}

		:global(.mdc-line-ripple::before),
		:global(.mdc-line-ripple::after) {
			border-bottom-color: $length-warning !important;
		}

		:global(.mdc-text-field--filled) {
			background-color: rgba($length-warning, 0.15) !important;
		}

		:global(.mdc-text-field--filled .mdc-text-field__ripple::before),
		:global(.mdc-text-field--filled .mdc-text-field__ripple::after) {
			background-color: $length-warning !important;
		}

		:global(.mdc-text-field-helper-text) {
			color: $length-warning !important;
		}
	}
</style>
